'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, createContext, useContext, useState } from 'react';
import type { TopNavV6Props, TopNavV6SubNavItem } from './TopNavV6Props';
interface TopNavV6ContextType {
  expandedNavItem: string | null;
  setExpandedNavItem: (item: string | null) => void;
  isSubNavExpanded: boolean;
  setSubNavExpanded: (expanded: boolean) => void;
  isMobileMenuOpen: boolean;
  setIsMobileMenuOpen: (open: boolean) => void;
  selectedThirdLevelMenu: TopNavV6SubNavItem | null;
  setSelectedThirdLevelMenu: (item: TopNavV6SubNavItem | null) => void;
  isAccountExpanded: boolean;
  setAccountExpanded: (expanded: boolean) => void;
  isSearchOpen: boolean;
  setSearchOpen: (open: boolean) => void;
  account?: TopNavV6Props['account'];
}
const TopNavV6Context = createContext<TopNavV6ContextType>({
  expandedNavItem: null,
  setExpandedNavItem: () => {},
  isSubNavExpanded: false,
  setSubNavExpanded: () => {},
  isMobileMenuOpen: false,
  setIsMobileMenuOpen: () => {},
  selectedThirdLevelMenu: null,
  setSelectedThirdLevelMenu: () => {},
  isAccountExpanded: false,
  setAccountExpanded: () => {},
  isSearchOpen: false,
  setSearchOpen: () => {},
  account: undefined
});
export const TopNavV6Provider = t0 => {
  const $ = _c(11);
  const {
    children,
    account
  } = t0;
  const [expandedNavItem, setExpandedNavItem] = useState(null);
  const [isSubNavExpanded, setSubNavExpanded] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [selectedThirdLevelMenu, setSelectedThirdLevelMenu] = useState(null);
  const [isAccountExpanded, setAccountExpanded] = useState(false);
  const [isSearchOpen, setSearchOpen] = useState(false);
  let t1;
  if ($[0] !== account || $[1] !== expandedNavItem || $[2] !== isAccountExpanded || $[3] !== isMobileMenuOpen || $[4] !== isSearchOpen || $[5] !== isSubNavExpanded || $[6] !== selectedThirdLevelMenu) {
    t1 = {
      expandedNavItem,
      setExpandedNavItem,
      isSubNavExpanded,
      setSubNavExpanded,
      isMobileMenuOpen,
      setIsMobileMenuOpen,
      selectedThirdLevelMenu,
      setSelectedThirdLevelMenu,
      isAccountExpanded,
      setAccountExpanded,
      isSearchOpen,
      setSearchOpen,
      account
    };
    $[0] = account;
    $[1] = expandedNavItem;
    $[2] = isAccountExpanded;
    $[3] = isMobileMenuOpen;
    $[4] = isSearchOpen;
    $[5] = isSubNavExpanded;
    $[6] = selectedThirdLevelMenu;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== children || $[9] !== t1) {
    t2 = <TopNavV6Context.Provider value={t1}>{children}</TopNavV6Context.Provider>;
    $[8] = children;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
export const useTopNavV6 = () => {
  const context = useContext(TopNavV6Context);
  if (!context) {
    throw new Error("useTopNavV6 must be used within a TopNavV6Provider");
  }
  return context;
};